import axios from "axios";
import axiosRetry from "axios-retry";
import { environment } from "@/environment";

function createAccountSetInstance(baseURL) {
  const instance = axios.create({
    baseURL,
    timeout: 30000,
  });

  axiosRetry(instance, { retry: 3 });

  instance.interceptors.request.use((config) => {
    config.withCredentials = true;
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error.response &&
        error.response.status == 401 &&
        location.host.indexOf("localhost") == -1
      ) {
        location.href = environment.gwApi + "salary.aspx";
      }
      return Promise.reject(error);
    },
  );

  return instance;
}

const accountSetApiInstances = {
  300: createAccountSetInstance(environment.jzAccountApi),
  400: createAccountSetInstance(environment.ycAccountApi),
  500: createAccountSetInstance(environment.jzProAccountApi),
  600: createAccountSetInstance(environment.ycFreeAccountApi),
  700: createAccountSetInstance(environment.jzAccountApi),
  800: createAccountSetInstance(environment.jzProAccountApi),
};

export default accountSetApiInstances;
